import React from 'react';
import { Divider } from 'semantic-ui-react'

const ConfServ1 = ({autorizacUA, styles, handleClickCl, handleClickSubcl, handleClickTT, handleClickRegr}) => {
  const a250101 = autorizacUA.findIndex( autorizac => autorizac === "250101" );
  const a250105 = autorizacUA.findIndex( autorizac => autorizac === "250105" );
  const a250107 = autorizacUA.findIndex( autorizac => autorizac === "250107" );

  return (
    <div>

      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a250101!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickCl}>
          <i className="large cube violet icon"></i>
          Clases
        </button>
      }
      {a250105!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSubcl}>
          <i className="large cubes violet icon"></i>
          Subclases
        </button>
      }
      {a250107!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickTT}>
          <i className="large cube violet icon"></i>
          Tipos de tecnología
        </button>
      }
      <Divider inverted />
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default ConfServ1
